import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";

import { Dropdown } from "semantic-ui-react";

export function FieldOptions({
  initialValue,
  onChange,
  formSubmitted,
  ...props
}) {
  const toOption = (v) => {
    return { key: v, value: v, text: v };
  };

  const [options, setOptions] = useState((initialValue || []).map(toOption));
  const [searchInput, setSearchInput] = useState("");
  const [selected, setSelected] = useState(initialValue || []);

  const resetForm = useCallback(() => {
    setOptions((initialValue || []).map(toOption));
    setSelected(initialValue || []);
    setSearchInput("");
  }, [setSearchInput, setSelected, setOptions, initialValue]);

  useEffect(() => {
    if (formSubmitted) resetForm();
  }, [resetForm, formSubmitted]);

  return (
    <Dropdown
      search
      selection
      multiple
      allowAdditions={Boolean(searchInput.trimStart().length)}
      searchInput={{ value: searchInput }}
      closeOnChange
      options={options}
      fluid
      noResultsMessage={null}
      placeholder="Add field options"
      icon=""
      value={selected}
      data-test="options-dropdown"
      onSearchChange={(e) => {
        setSearchInput(e.target.value.trimStart());
      }}
      onAddItem={(_, { value }) => {
        setOptions((prev) => {
          return value.trim().length
            ? prev.concat(toOption(value.trim()))
            : prev;
        });
      }}
      onChange={(_, { value }) => {
        const trimmedValue = value.map((v) => {
          return v.trim();
        });

        onChange(trimmedValue);
        setSelected(trimmedValue);
        setSearchInput("");
      }}
      {...props}
    />
  );
}

FieldOptions.propTypes = {
  initialValue: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  formSubmitted: PropTypes.bool,
};

FieldOptions.defaultProps = {
  initialValue: [],
  formSubmitted: false,
};

export default FieldOptions;
